module.exports = __webpack_public_path__ + "static/media/quillbot-flow.bda09593.png";